import * as TRIGGERS from './triggers.constants';
import { ITrigger as Trigger } from '../../models';

/** LOAD */
export function loadTriggers() {
    return { type: TRIGGERS.TRIGGERS_LOAD };
}

export function loadTriggersSuccess(data: Trigger[]) {
    return { type: TRIGGERS.TRIGGERS_LOAD_SUCCESS, payload: data };
}

export function loadTriggersError(error: any) {
    return { type: TRIGGERS.TRIGGERS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addTriggers(targetTriggers: Trigger[]) {
    return { type: TRIGGERS.TRIGGERS_ADD, payload: targetTriggers };
}

export function addTriggersSuccess(targetTriggers: Trigger[]) {
    return { type: TRIGGERS.TRIGGERS_ADD_SUCCESS, payload: targetTriggers };
}

export function addTriggersError(error: any) {
    return { type: TRIGGERS.TRIGGERS_ADD_ERROR, payload: error };
}

export function addTrigger(trigger: Trigger) {
    return { type: TRIGGERS.TRIGGER_ADD, payload: trigger };
}

export function addTriggerSuccess(trigger: Trigger) {
    return { type: TRIGGERS.TRIGGER_ADD_SUCCESS, payload: trigger };
}

export function addTriggerError(error: any) {
    return { type: TRIGGERS.TRIGGER_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateTriggers(targetTriggers: Trigger[]) {
    return { type: TRIGGERS.TRIGGERS_UPDATE, payload: targetTriggers };
}

export function updateTriggersSuccess(targetTriggers: Trigger[]) {
    return { type: TRIGGERS.TRIGGERS_UPDATE_SUCCESS, payload: targetTriggers };
}

export function updateTriggersError(error: any) {
    return { type: TRIGGERS.TRIGGERS_UPDATE_ERROR, payload: error };
}

export function updateTrigger(trigger: Trigger) {
    return { type: TRIGGERS.TRIGGER_UPDATE, payload: trigger };
}

export function updateTriggerSuccess(trigger: Trigger) {
    return { type: TRIGGERS.TRIGGER_UPDATE_SUCCESS, payload: trigger };
}

export function updateTriggerError(error: any) {
    return { type: TRIGGERS.TRIGGER_UPDATE_ERROR, payload: error };
}

/** DELETE */
export function deleteTriggers(guids: string[]) {
    return { type: TRIGGERS.TRIGGERS_DELETE, payload: guids };
}

export function deleteTriggersSuccess(Triggers: Trigger[]) {
    return { type: TRIGGERS.TRIGGERS_DELETE_SUCCESS, payload: Triggers };
}

export function deleteTriggersError(error: any) {
    return { type: TRIGGERS.TRIGGERS_DELETE_ERROR, payload: error };
}

export function deleteTrigger(guid: string) {
    return { type: TRIGGERS.TRIGGER_DELETE, payload: guid };
}

export function deleteTriggerSuccess(trigger: Trigger) {
    return { type: TRIGGERS.TRIGGER_DELETE_SUCCESS, payload: trigger };
}

export function deleteTriggerError(error: any) {
    return { type: TRIGGERS.TRIGGER_DELETE_ERROR, payload: error };
}